import { getHeader, socketUrl } from './config'
import Echo from 'laravel-echo'
window.io = require('socket.io-client')
let EchoInstance = new Echo({
  broadcaster: 'socket.io',
  host: 'https://' + socketUrl,
  auth: {
    headers: getHeader()
  }
})

export default EchoInstance



// WEBPACK FOOTER //
// ./src/echoClient.js